import React, { useEffect, useState } from "react";
import { getFetch, postFetch } from "../../../../../../fetch/fetch";
import { Button } from "@mui/joy";
import { DataGridPremium, GridFilterModel } from "@mui/x-data-grid-premium";
import { dateToDateString } from "../../../etc/etcfunctions";
import { englishLocationToKorean } from "../../../../../../data/locationFuntion";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const HeadOfficeApproval: React.FC<any> = (props) => {

    const [alignment, setAlignment] = useState('waiting');
    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [columns, setColumns] = useState<any[]>([
        { field: "name", headerName: "근무자", width: 150 },
        { field: "targetDate", headerName: "근무 날짜", width: 150 },
        { field: "location", headerName: "근무 지점", width: 100 },
        { field: "korean", headerName: "근무 종류", width: 150 },
        { field: "status", headerName: "승인 상태", width: 150 },
        {
            field: "approveBtn", headerName: "승인", width: 150, renderCell: (params: any) => {

                const id = params.row.id;

                const handleApprove = async () => {
                    try {
                        if (!id) {
                            return;
                        }

                        setLoading(true);

                        const result: any = await postFetch("/dashboard/salary/processrequestedheadofficeforwork", {
                            workId: id,
                            status: 1
                        });

                        setLoading(false);
                        setUpdate(Math.random());

                    } catch (e) {
                        console.log(e);
                    }
                };

                return (
                    <div>
                        <Button
                            onClick={handleApprove}
                            disabled={loading}
                            size="sm"
                            variant="outlined"
                        >
                            승인
                        </Button>
                    </div>
                )

            }
        },
        {
            field: "rejectBtn", headerName: "거절", width: 150, renderCell: (params: any) => {

                const id = params.row.id;

                const handleReject = async () => {
                    try {
                        if (!id) {
                            return;
                        }

                        setLoading(true);

                        const result: any = await postFetch("/dashboard/salary/processrequestedheadofficeforwork", {
                            workId: id,
                            status: 2
                        });

                        setLoading(false);
                        setUpdate(Math.random());

                    } catch (e) {
                        console.log(e);
                    }

                };

                return (
                    <div>
                        <Button
                            onClick={handleReject}
                            disabled={loading}
                            size="sm"
                            variant="outlined"
                            color="neutral"
                        >
                            거절
                        </Button>
                    </div>
                )

            }
        }
    ]);
    const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
        items: [
            { id: 1, field: 'status', operator: 'contains', value: "대기중" },
        ],
    });
    const [update, setUpdate] = useState(0);

    useEffect(() => {
        getRequestedHeadOfficeForWorks();
    }, [update]);

    const getRequestedHeadOfficeForWorks = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch("/dashboard/salary/requestedheadofficeforwork");

            if (result.message === "success") {

                const newRows: any = [];

                result.data.forEach((work: any) => {

                    const oneRow: any = {};

                    oneRow.id = work.id;
                    oneRow.name = work.name;
                    oneRow.targetDate = dateToDateString(new Date(work.targetDate));
                    oneRow.location = englishLocationToKorean(work.location);

                    const workLocation = work.location;

                    const data = work.data[workLocation].jobs.find((jobItem: any) => jobItem.english === work.english);

                    oneRow.korean = data.korean;

                    if (work.status === 0) {
                        oneRow.status = "대기중";
                    } else if (work.status === 1) {
                        oneRow.status = "승인";
                    } else if (work.status === 2) {
                        oneRow.status = "거절";
                    }

                    console.log("oneRow", oneRow);

                    newRows.push(oneRow);

                });

                setRows([...newRows]);

            }


            setLoading(false);

        } catch (e) {
            console.log(e);
        }

    }

    const handleChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
        if(!newAlignment) {
            return;
        }

        setAlignment(newAlignment);

        if (newAlignment === "waiting") {
            setFilterModel({
                items: [
                    { id: 1, field: 'status', operator: 'contains', value: "대기중" },
                ],
            });
        } else if (newAlignment === "approved") {
            setFilterModel({
                items: [
                    { id: 1, field: 'status', operator: 'contains', value: "승인" },
                ],
            });
        } else if (newAlignment === "rejected") {   
            setFilterModel({
                items: [
                    { id: 1, field: 'status', operator: 'contains', value: "거절" },
                ],
            });
        }


    }

    return (
        <div>
            <div>
                <div style={{ marginBottom: "24px", marginTop : "24px" }}>
                    <ToggleButtonGroup
                        color="primary"
                        value={alignment}
                        exclusive
                        onChange={handleChange}
                    >
                        <ToggleButton value="waiting">대기중</ToggleButton>
                        <ToggleButton value="approved">승인</ToggleButton>
                        <ToggleButton value="rejected">거절</ToggleButton>
                    </ToggleButtonGroup>
                </div>
            </div>
            <div style={{
                height: "600px",
                width: "1200px",
            }}>

                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    loading={loading}
                    density="compact"
                    hideFooter={true}
                    filterModel={filterModel}
                    onFilterModelChange={(newModel) => setFilterModel(newModel)}
                />
            </div>
        </div>
    )
};

export default HeadOfficeApproval;